module.exports = "<div id=\"my-custom-window\">\n  Hello, custom window!\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/sample/view.txt
 ** module id = 29
 ** module chunks = 0
 **/